import React, { useState } from "react"
import { ListboxButton, ListboxOption } from "@headlessui/react"

import { ListBox } from "../../../lib/fragments/ListBox"
import { textCaseArray } from "../../../utils/Constants"
import { ToggleSwitch } from "../../../components/utils/ToggleSwitch"

export const FreetextRestriction = ({ state, setstate, listboxHandler, blurHandler, changeHandler }) => {
    const toggleVisibility = (key: any, value: boolean) => {
        setstate((prevState: any) => ({
            ...prevState,
            show: {
                ...prevState.show,
                [key]: value,
            },
        }))
    }

    const toogleSwitchHandler = (e: any) => {
        let { input, posting } = state
        if (posting) return

        switch (e.target.name) {
            case 'text_case':
            case 'multiline':
                if (input.format?.key !== 'freetext') return
                break;

            default:
                break;
        }

        setstate((prev: any) => ({
            ...prev,
            input: {
                ...prev.input,
                [e.target.name]: e.target.checked
            }
        }))
    }

    const hideLengthVisibility = () => {
        toggleVisibility('minMaxVisibility', false)

        setstate((prev: any) => ({
            ...prev,
            input: {
                ...prev.input,
                minimum: '',
                maximum: '',
            }, errors: {
                ...prev.errors,
                minimum: '',
                maximum: '',
            }
        }))
    }

    return (
        <React.Fragment>
            <div className="w-full pb-4">
                <span className="block text-sm text-slate-800 dark:text-slate-300 pb-1">
                    Text Case <sub className="text-red-500 dark:text-red-500 text-sm">*</sub>

                    <span className="block text-xs text-slate-500 dark:text-slate-400 pb-1">
                        How text for this attribute should be displayed
                    </span>
                </span>

                <div className="pt-2 px-1 w-full md:max-w-[300px]">
                    <ListBox
                        value={state.input.text_case ? state.input.text_case?.key : ''}
                        eventHandler={(e: any) => listboxHandler(e, 'text_case')}
                        button={
                            <ListboxButton className="relative border w-full rounded-md py-2 pr-2 text-left cursor-default focus:ring-primary focus:border-primary sm:text-sm ring-slate-300 dark:ring-slate-600 focus:ring-orange-600 focus:outline-none focus:border-0 focus:ring-primary focus:outline-orange-500 border-slate-300 dark:border-slate-600 dark:text-white">
                                <div className="flex w-full items-center align-middle">
                                    <div className="flex-grow flex items-center">
                                        <span className="truncate ml-3 font-normal group-data-[selected]:font-semibold">
                                            <div className="flex items-center gap-x-4">
                                                <span className="truncate group-data-[selected]:font-semibold">
                                                    {state.input.text_case?.label}
                                                </span>
                                            </div>
                                        </span>
                                    </div>

                                    <span className="fa-light fa-chevron-down focus:text-primary float-end"></span>
                                </div>
                            </ListboxButton>
                        }
                        options={
                            <>
                                {
                                    textCaseArray.map((textCase: any) => (
                                        <ListboxOption key={`attr-text-case-${textCase.key}`} value={textCase} className="group relative cursor-default select-none py-2 pl-3 pr-9 data-[selected]:text-orange-600 data-[focus]:bg-orange-100 dark:data-[focus]:bg-orange-900/70 data-[focus]:text-orange-700 dark:data-[focus]:text-orange-500 rounded-md w-full">
                                            <div className="flex items-center gap-x-4">
                                                <span className="truncate group-data-[selecteßd]:font-medium">
                                                    {textCase.label}
                                                </span>
                                            </div>

                                            <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-orange-600 group-[&:not([data-selected])]:hidden">
                                                <span className="fa-light fa-check"></span>
                                            </span>
                                        </ListboxOption>
                                    ))
                                }
                            </>
                        }
                    />
                </div>

                {
                    state.errors.display_style.length > 0 && (
                        <span className='invalid-feedback text-xs text-red-600 dark:text-red-400 pl-1 pt-1'>
                            {state.errors.display_style}
                        </span>
                    )
                }
            </div>

            <div className="w-full py-4 border-t border-slate-300 dark:border-slate-600">
                <ToggleSwitch
                    name={'multiline'}
                    label={'Multi-line Input'}
                    checked={state.input.multiline}
                    changeHandler={toogleSwitchHandler}
                    description={"Allow users to write longer responses"}
                    disabled={state.input.format?.key === 'freetext' ? false : true}
                />
            </div>

            <div className="w-full py-4 border-t border-slate-300 dark:border-slate-600">
                <ToggleSwitch
                    label={'Allow Special Characters'}
                    name={'allow_special'}
                    disabled={false}
                    changeHandler={toogleSwitchHandler}
                    checked={state.input.allow_special}
                    description={"Permit the use of non-alphanumeric symbols (e.g., *, +, |, %) in this field’s values."}
                />
            </div>

            <div className="w-full py-4 border-t border-slate-300 dark:border-slate-600">
                <ToggleSwitch
                    label={'Required?'}
                    name={'mandatory'}
                    checked={state.input.mandatory}
                    changeHandler={toogleSwitchHandler}
                    description={"Ensures a value is provided before submitting"}
                />
            </div>

            <div className="w-full pb-5">
                <button type="button" onClick={() => toggleVisibility('minMaxVisibility', true)} className={`text-orange-500 md:py-0 hover:text-orange-700 ${state.show.minMaxVisibility ? 'hidden' : 'block mt-2 md:mb-0 mb-3'}`}>
                    <span className="text-sm">Customize Text Length</span>
                </button>

                {
                    state.show.minMaxVisibility && (
                        <>
                            <div className="w-full pt-4 pb-1 border-t border-slate-300 dark:border-slate-600 flex md:flex-row flex-col align-middle md:items-center md:gap-x-3 gap-y-3">
                                <div className="flex-1">
                                    <span className='label text-slate-800 dark:text-slate-200 disabled:text-slate-600 text-sm'>
                                        Text length
                                    </span>

                                    <span className="block text-xs text-slate-500 dark:text-slate-300 pb-1">
                                        Set a character limit
                                    </span>
                                </div>

                                <div className="md:w-64 flex w-full items-center border border-gray-300 rounded-md overflow-hidden">
                                    <input
                                        type="number"
                                        name="minimum"
                                        placeholder="Min"
                                        onBlur={blurHandler}
                                        onChange={changeHandler}
                                        value={state.input.minimum}
                                        className="w-full px-3 py-2 text-sm focus:outline-none focus:ring-0 focus:border-none"
                                    />

                                    <div className="w-px h-6 bg-gray-300 dark:bg-gray-400 mx-1"></div>

                                    <input
                                        type="number"
                                        name="maximum"
                                        placeholder="Max"
                                        onBlur={blurHandler}
                                        onChange={changeHandler}
                                        value={state.input.maximum}
                                        className="w-full px-3 py-2 text-sm focus:outline-none focus:ring-0 focus:border-none"
                                    />
                                </div>
                            </div>

                            {
                                state.errors.minimum.length > 0 && (
                                    <span className='invalid-feedback text-xs block text-red-600 dark:text-red-400 pt-1'>
                                        {state.errors.minimum}
                                    </span>
                                )
                            }

                            {
                                state.errors.maximum.length > 0 && (
                                    <span className='invalid-feedback text-xs block text-red-600 dark:text-red-400 pt-1'>
                                        {state.errors.maximum}
                                    </span>
                                )
                            }

                            <div className="w-full md:w-auto flex flex-row pt-2">
                                <button type="button" onClick={() => hideLengthVisibility()} className={`text-orange-600 dark:text-orange-500 md:py-0 hover:text-orange-700 dark:hover:text-orange-400`}>
                                    <span className="text-sm">Allow Any Length</span>
                                </button>
                            </div>
                        </>
                    )
                }
            </div>
        </React.Fragment>
    )
}